<div class="fuild-container login">
  <div class="row">
    <div class="col-md-8 banner" banner></div>
    <div class="col-md-4 form">
      <div class="p-5">
        <div class="brand-logo text-center">
          <img [src]="logo">
        </div>
        <br/>
        <div class="text-center d-none">
          <h1 class="h4 text-gray-900 mb-4">Welcome Back!</h1>
        </div>
        <alert></alert>
        <form class="login" [formGroup]="resetForm" (ngSubmit)="onSubmit()" novalidate>
          <div class="form-group">
            <input type="text" formControlName="email" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': submitted &amp;&amp; resetForm.controls.email.errors }" placeholder="Enter your email..." />
            @if (submitted && resetForm.controls.email.errors) {
              <div class="text-danger">
                @if (resetForm.controls.email.errors.required) {
                  <div>Email is required</div>
                }
                @if (resetForm.controls.email.errors.email) {
                  <div>Email must be a valid email address</div>
                }
              </div>
            }
          </div>
          <button type="submit"class="btn btn-sm btn-sm btn-primary btn-icon-split btn-block" [disabled]="loading">
            <span class="icon text-white-50">
              <i class="fas fa-arrow-right"></i>
            </span>
            <span class="text">Reset your password</span>
          </button>
        </form>
        <hr>
          <div class="text-center float-left">
            <a class="small" [routerLink]="['/login']">Back to login</a>
          </div>
          <div class="text-center float-right">
            <!--<a class="small" href="register.html">Create an Account!</a>-->
          </div>
          <br/><br/>
          <br/><br/>
          <div class="text-center">
            <a href="https://www.sullivanstrickler.com/contact-us/" target="_blank" class="btn btn-primary btn-demo btn-block">
              Request a Free Demo
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>